import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '..'
import { ElapsedMillisecond } from '../../../../utils/dateUtil'
import { GetCategoryMstDto } from '../../../../dataAccess/webApi/dto/categoryMstDto'

export interface MemberModifyUserEntry {
  name: string
  kana: string
  postalCode: string
  address1: string
  address2: string
  buildingNameRoomNumber: string
  residenceCategory: string
  residenceCategoryName: string
  relationship: string
  timeRequired: string

  spouseName: string
  spouseKana: string
  spouseTel: string
  spouseEmail: string
  spouseRelationship: string
  spouseCompanyName: string
  spouseCompanyAddress: string
  spouseCompanyTel: string
  spouseTimeRequired: string

  emergencyContactName1: string
  emergencyContactKana1: string
  emergencyContactRelationship1: string
  emergencyContactCompany1: string
  emergencyContactAddress1: string
  emergencyContactTel1: string
  emergencyContactEmail1: string
  emergencyContactTimeRequired1: string
  emergencyContactOther1: string

  emergencyContactName2: string
  emergencyContactKana2: string
  emergencyContactRelationship2: string
  emergencyContactCompany2: string
  emergencyContactAddress2: string
  emergencyContactTel2: string
  emergencyContactEmail2: string
  emergencyContactTimeRequired2: string
  emergencyContactOther2: string

  emergencyContactName3: string
  emergencyContactKana3: string
  emergencyContactRelationship3: string
  emergencyContactCompany3: string
  emergencyContactAddress3: string
  emergencyContactTel3: string
  emergencyContactEmail3: string
  emergencyContactTimeRequired3: string
  emergencyContactOther3: string

  isDisabledResidenceCategory: boolean
}

export interface MemberModifyChildEntry {
  childId: string
  name: string
  kana: string
  birthday: ElapsedMillisecond
  brothersSistersFlag: string
  multipleBirthsFlag: string
  gender: string
  bloodType: string
  maternalHandbookNo: string
}

interface MemberModifyState {
  userEntry?: MemberModifyUserEntry
  childEntry?: MemberModifyChildEntry
  /** 排他制御用更新日時 */
  updateDatetime?: string
  categoryMap?: {[key:string]: GetCategoryMstDto}
}

const initialState: MemberModifyState = {}

export const memberModifySlice = createSlice({
  name: 'memberModify',
  initialState,
  reducers: {
    setMemberModifyUser: (state, action: PayloadAction<MemberModifyUserEntry>) => {
      state.userEntry = action.payload
    },
    setMemberModifyChild: (state, action: PayloadAction<MemberModifyChildEntry>) => {
      state.childEntry = action.payload
    },
    setMemberModifyUpdateDatetime: (state, action: PayloadAction<string>) => {
      state.updateDatetime = action.payload
    },
    setMemberModifyCategoryMap: (state, action: PayloadAction<{[key:string]: GetCategoryMstDto}>) => {
      state.categoryMap = action.payload
    },
    clearMemberModify: (state) => {
      delete state.userEntry
      delete state.childEntry
      delete state.updateDatetime
      delete state.categoryMap
    },
  },
})
export const {
  setMemberModifyUser,
  setMemberModifyChild,
  setMemberModifyUpdateDatetime,
  setMemberModifyCategoryMap,
  clearMemberModify,
} = memberModifySlice.actions
export const selectMemberModifyUserEntry = (state: RootState) => state.memberModify.userEntry
export const selectMemberModifyChildEntry = (state: RootState) => state.memberModify.childEntry
export const selectMemberModifyUpdateDatetime = (state: RootState) => state.memberModify.updateDatetime
export const selectMemberModifyCategoryMap = (state: RootState) => state.memberModify.categoryMap
export default memberModifySlice.reducer
